import { getUrl } from 'helpers';
import { game } from 'setup/game';
import styled from 'styled-components';

const { ball } = game;

export const Container = styled.div<LandingBContainerProps>`
    align-items: stretch;
    background-image: url('${({ $backgroundImage }) => getUrl($backgroundImage)}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: calc(100vh - 150px);

    @media (min-width: 1200px) {
        flex-direction: row;
    }
`;

export const Left = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 50px;
    gap: 50px;

    @media (min-width: 992px) {
        align-items: flex-start;
        flex-direction: row-reverse;
        justify-content: center;
        gap: 30px;
    }

    @media (min-width: 1200px) and (max-width: 1599px) {
        justify-content: flex-start;
        flex: 2;
    }
`;

export const LeftContent = styled.div`
    max-width: 470px;

    @media (min-width: 992px) {
        padding-top: ${ball.size - ball.start}px;
    }
`;

export const LeftBoard = styled.div`
    @media (min-width: 1200px) and (max-width: 1599px) {
        position: absolute;
        right: 0;
        top: 0;
    }
`;

export const Right = styled.div`
    background-color: rgba(30, 30, 30, 0.4);
    flex: 1;
    padding: 40px 60px;

    @media (min-width: 1200px) {
        max-width: 570px;
    }
`;

export const Points = styled.div`
    align-items: center;
    column-gap: 10px;
    display: grid;
    grid-template-columns: 36px 1fr;
    row-gap: 16px;
`;

export const Arrow = styled.div`
    position: absolute;
    left: -90px;
    top: -10px;
    transform: rotate(40deg);
`;
